export default __webpack_public_path__ + "static/media/img_chart_grade_SS.10ff391f8735019004087688dc17b703.svg";